import styled, { css } from 'styled-components';
export var CellActions = styled.div.withConfig({
  displayName: "partials__CellActions",
  componentId: "sc-1jotpfz-0"
})(["display:inline-flex;justify-content:flex-end;"]);
var disabledStyles = css(["cursor:not-allowed;color:", ";&:hover{color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.ui;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.ui;
});
var largeStyles = css(["width:32px;height:32px;"]);
var mediumStyles = css(["width:22px;height:22px;"]);
var borderedStyles = css(["", " ", " border-color:", ";border-radius:10px;"], function (_ref3) {
  var size = _ref3.size;
  return size === 'medium' && 'border: 1.5px solid;';
}, function (_ref4) {
  var size = _ref4.size;
  return size === 'large' && 'border: 2.5px solid;';
}, function (_ref5) {
  var theme = _ref5.theme,
    $color = _ref5.$color;
  return theme.colors["".concat($color)];
});
export var SCellAction = styled.button.attrs(function (props) {
  return {
    $bordered: props.bordered || false,
    $color: props.color || 'ui',
    size: props.size || 'medium'
  };
}).withConfig({
  displayName: "partials__SCellAction",
  componentId: "sc-1jotpfz-1"
})(["cursor:pointer;transition:0.15s;&,a,a:visited{color:", ";}svg{display:block;", " ", " padding:1.5px;vertical-align:middle;}&:hover{color:", ";}", " ", ""], function (_ref6) {
  var theme = _ref6.theme,
    $color = _ref6.$color;
  return theme.colors["".concat($color)];
}, function (_ref7) {
  var size = _ref7.size;
  return size === 'medium' && mediumStyles;
}, function (_ref8) {
  var size = _ref8.size;
  return size === 'large' && largeStyles;
}, function (_ref9) {
  var theme = _ref9.theme,
    $color = _ref9.$color;
  return theme.colors["".concat($color, "D")];
}, function (_ref10) {
  var disabled = _ref10.disabled;
  return disabled && disabledStyles;
}, function (_ref11) {
  var $bordered = _ref11.$bordered;
  return $bordered && borderedStyles;
});